import {useEffect, useState} from 'react'
import {css} from '@emotion/react'
import BaseMap from '../../BaseMap.jsx'
import {DiffMapProvider} from './DiffMapContext.jsx'
import ToolBar from './ToolBar.jsx'
import useDiffMap from './useDiffMap.mjs'
import useMapData from './useMapData.mjs'

const cssDiffMap = css({
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: 'auto 1fr',
    overflow: 'hidden',
})

const cssToolBar = css({
    gridColumn: 'span 2',
})

const components = {ToolBar: () => null}

export default function DiffMapWrapper({
    basDpId,
    basDppId,
    basMapVerId,
    inits,
    mergeId,
    tarDpId,
    tarDppId,
    tarMapVerId,
    type,
    onLoad,
    ...props
}) {
    const [noRefRevChgFlag, setNoRefRevChgFlag] = useState('0')

    const mapData = useMapData({
        basDpId,
        basDppId,
        basMapVerId,
        mergeId,
        noRefRevChgFlag,
        tarDpId,
        tarDppId,
        tarMapVerId,
        type,
    })

    useEffect(
        () => {
            if (mapData) {
                onLoad?.(mapData)
            }
        },

        [mapData]
    )

    if (! mapData) {
        return null
    }

    const {differences, left, right} = mapData

    // SoftwareMap 不支持受控，故采用嵌套组件定义的方式实现刷新数据
    const DiffMap = ({
        children,
        differences,
        inits,
        left,
        right,
        ...props
    }) => {
        const [leftMap, setLeftMap] = useState()
        const [rightMap, setRightMap] = useState()

        const selectFirstDifference = (
            0 < differences.length &&
            void 0 === inits?.selectedNodes
        )

        const diffMap = useDiffMap({
            differences,
            leftMap,
            rightMap,
            selectFirstDifference,
        })

        Object.assign(diffMap, {noRefRevChgFlag, setNoRefRevChgFlag})

        const _inits = selectFirstDifference ?
            {...inits, selectedNodes: false} : inits

        return (
            <div
                css={cssDiffMap}
                {...props}
            >
                <DiffMapProvider value={diffMap}>
                    <ToolBar
                        css={cssToolBar}
                        diffMap={diffMap}
                    />
                </DiffMapProvider>

                <BaseMap
                    components={components}
                    readMap={() => left}
                    inits={_inits}
                    onLoad={setLeftMap}
                />

                <BaseMap
                    components={components}
                    readMap={() => right}
                    inits={_inits}
                    onLoad={setRightMap}
                />
            </div>
        )
    }

    return (
        <DiffMap
            differences={differences}
            left={left}
            right={right}
            {...props}
        />
    )
}
